import { render, staticRenderFns } from "./Empfaenger.vue?vue&type=template&id=94d66124"
import script from "./Empfaenger.vue?vue&type=script&lang=js"
export * from "./Empfaenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports